import { render, staticRenderFns } from "./SalairesListRapp.vue?vue&type=template&id=1b4f1db3&scoped=true&"
import script from "./SalairesListRapp.vue?vue&type=script&lang=js&"
export * from "./SalairesListRapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4f1db3",
  null
  
)

export default component.exports